export function buildClassPublicShareUrl(input: {
  portalBase: string | undefined | null;
  shareToken: string;
  studioId?: string;
}): string {
  const rawBase =
    typeof input.portalBase === 'string' ? input.portalBase.trim() : '';
  const base = rawBase.length > 0 ? rawBase.replace(/\/$/, '') : '';
  const shareToken =
    typeof input.shareToken === 'string' ? input.shareToken.trim() : '';

  if (!base || shareToken.length === 0) {
    return '';
  }

  try {
    const u = new URL(
      `${base}/public-class-share/${encodeURIComponent(shareToken)}`,
    );
    const studioId =
      typeof input.studioId === 'string' ? input.studioId.trim() : '';
    if (studioId.length > 0) {
      u.searchParams.set('studioId', studioId);
    }
    return u.toString();
  } catch {
    return '';
  }
}

export function buildClassPublicShareEmbedUrl(shareUrl: string): string {
  const trimmed = typeof shareUrl === 'string' ? shareUrl.trim() : '';
  if (trimmed.length === 0) {
    return '';
  }

  try {
    const url = new URL(trimmed);
    url.searchParams.delete('embedded');
    return url.toString();
  } catch {
    return '';
  }
}

export function buildClassPublicShareIframeEmbedHtml(embedUrl: string): string {
  const trimmed = typeof embedUrl === 'string' ? embedUrl.trim() : '';
  if (trimmed.length === 0) {
    return '';
  }

  return `<iframe
  title="Class details"
  src="${trimmed}"
  width="100%"
  height="850"
  style="width:100%;min-height:850px;border:0"
  loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"
></iframe>`;
}

function coerceIdValue(id: unknown): string | null {
  if (typeof id === 'string' && id.trim().length > 0) {
    return id.trim();
  }
  if (
    id != null &&
    typeof id === 'object' &&
    typeof (id as { toString?: () => string }).toString === 'function'
  ) {
    const asString = (id as { toString: () => string }).toString().trim();
    return asString.length > 0 && asString !== '[object Object]'
      ? asString
      : null;
  }
  return null;
}

/** Null-safe class id from create-class API payload (`_id` / `id`, nested `data`). */
export function resolveCreatedClassId(response: unknown): string | null {
  if (response == null || typeof response !== 'object') {
    return null;
  }
  const record = response as Record<string, unknown>;
  const direct =
    coerceIdValue(record._id) ?? coerceIdValue(record.id);
  if (direct) {
    return direct;
  }
  if (record.data != null && typeof record.data === 'object') {
    const nested = record.data as Record<string, unknown>;
    return coerceIdValue(nested._id) ?? coerceIdValue(nested.id);
  }
  return null;
}
